import { Alert, Grid, SxProps, Theme } from '@mui/material';

import { StyledWarningIcon } from './warningBox.styled';

interface WarningBoxProps {
  visible?: boolean;
  children?: React.ReactNode;
  sx?: SxProps<Theme>;
}

export const WarningBox = ({
  visible = true,
  children,
  sx,
}: WarningBoxProps) => {
  if (!visible) return null;

  return (
    <Grid container>
      <Alert severity="warning" sx={sx} icon={<StyledWarningIcon />}>
        {children}
      </Alert>
    </Grid>
  );
};
